import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../Resources/Resource.css'
import 'font-awesome/css/font-awesome.min.css'
import axios from 'axios'

const userid = localStorage.getItem('userid')

function PracticeTest() {
  const [english_count, setenglishcount] = useState([])
  const [math_count, setmathcount] = useState([])
  const [reading_count, setreadingcount] = useState([])
  const [science_count, setsciencecount] = useState([])
  const { id } = useParams()

  useEffect(() => {
    getPracticeTests()
  }, [])
  const getPracticeTests = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}actsectionstatus/${userid}/${id}`
    )
    if (response.status === 200) {
      setenglishcount(response.data.english_count)
      setmathcount(response.data.math_count)
      setreadingcount(response.data.reading_count)
      setsciencecount(response.data.science_count)
    }
  }

  // Modern card-based layout
  return (
    <section className="bg-white border rounded-[10px] border-[#F0F0F0] max-w-5xl mx-auto mt-8 p-0 shadow">
      {/* Header and Summary */}
      <div className="flex flex-col md:flex-row items-center justify-between border-b border-[#F0F0F0] px-8 py-6 gap-4">
        <div>
          <h3 className="text-xl font-bold text-[#030303] mb-0">
            ACT Practice Test
          </h3>
        </div>
        <div className="text-[#535862] text-base font-medium ml-auto">
          {/* You can make this dynamic if you want */}
          {`Section Completion: ${
            Number(english_count) +
            Number(math_count) +
            Number(reading_count) +
            Number(science_count)
          } of 4`}
        </div>
      </div>
      {/* Section Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
        {/* English Section */}
        <div className="bg-white rounded-xl border border-[#F0F0F0] shadow-sm p-7 flex flex-col h-full">
          <div className="flex items-center mb-4">
            <div className="bg-[#DEEBFF] rounded-full p-3 mr-3">
              <i className="fa fa-book text-[#377DFF] text-2xl"></i>
            </div>
            <h4 className="text-[#030303] text-lg font-bold">English</h4>
          </div>
          <div className="mt-auto">
            {english_count === 1 ? (
              <span className="inline-block px-4 py-2 rounded-2xl bg-[#EFEFEF] text-[#030303] font-semibold">
                Completed Test Section
              </span>
            ) : (
              <a
                href={`/acttests/${id}/section/1`}
                className="inline-block px-4 py-2 rounded-2xl bg-[#DE3C7D] text-white font-semibold hover:bg-[#c72c6a] transition"
              >
                Begin Test Section
              </a>
            )}
          </div>
        </div>
        {/* Math Section */}
        <div
          className={`bg-white rounded-xl border border-[#F0F0F0] shadow-sm p-7 flex flex-col h-full ${
            english_count === 1 ? '' : 'opacity-60 pointer-events-none'
          }`}
        >
          <div className="flex items-center mb-4">
            <div className="bg-[#EAF6FF] rounded-full p-3 mr-3">
              <svg
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                className="text-[#4E57EF] text-2xl"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                />
                <path
                  fillRule="evenodd"
                  d="M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0zm2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z"
                />
              </svg>
            </div>
            <h4 className="text-[#030303] text-lg font-bold">Math</h4>
          </div>
          <div className="mt-auto">
            {math_count === 1 ? (
              <span className="inline-block px-4 py-2 rounded-2xl bg-[#EFEFEF] text-[#030303] font-semibold">
                Completed Test Section
              </span>
            ) : (
              <a
                href={`/acttests/${id}/section/2`}
                className="inline-block px-4 py-2 rounded-2xl bg-[#4E57EF] text-white font-semibold hover:bg-[#3746b3] transition"
              >
                Begin Test Section
              </a>
            )}
          </div>
        </div>
        {/* Reading Section */}
        <div
          className={`bg-white rounded-xl border border-[#F0F0F0] shadow-sm p-7 flex flex-col h-full ${
            math_count === 1 ? '' : 'opacity-60 pointer-events-none'
          }`}
        >
          <div className="flex items-center mb-4">
            <div className="bg-[#FFF4E6] rounded-full p-3 mr-3">
              <svg
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                className="text-[#F36F4A] text-2xl"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"
                />
                <path
                  fillRule="evenodd"
                  d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                />
              </svg>
            </div>
            <h4 className="text-[#030303] text-lg font-bold">Reading</h4>
          </div>
          <div className="mt-auto">
            {reading_count === 1 ? (
              <span className="inline-block px-4 py-2 rounded-2xl bg-[#EFEFEF] text-[#030303] font-semibold">
                Completed Test Section
              </span>
            ) : (
              <a
                href={`/acttests/${id}/section/3`}
                className="inline-block px-4 py-2 rounded-2xl bg-[#F36F4A] text-white font-semibold hover:bg-[#d95c2e] transition"
              >
                Begin Test Section
              </a>
            )}
          </div>
        </div>
        {/* Science Section */}
        <div
          className={`bg-white rounded-xl border border-[#F0F0F0] shadow-sm p-7 flex flex-col h-full ${
            reading_count === 1 ? '' : 'opacity-60 pointer-events-none'
          }`}
        >
          <div className="flex items-center mb-4">
            <div className="bg-[#EAF6FF] rounded-full p-3 mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="text-[#535862] text-2xl"
                fill="#377DFF"
                width="28"
                height="28"
              >
                <path d="M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"></path>
              </svg>
            </div>
            <h4 className="text-[#030303] text-lg font-bold">Science</h4>
          </div>
          <div className="mt-auto">
            {science_count === 1 ? (
              <span className="inline-block px-4 py-2 rounded-2xl bg-[#EFEFEF] text-[#030303] font-semibold">
                Completed Test Section
              </span>
            ) : (
              <a
                href={`/acttests/${id}/section/4`}
                className="inline-block px-4 py-2 rounded-2xl bg-[#535862] text-white font-semibold hover:bg-[#35394a] transition"
              >
                Begin Test Section
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default PracticeTest
